<template>
  <div class="nav">
    <div class="main">
      <div class="logo" @click="goHome">FilmHive</div>
      <ul class="head">
        <li @click="goHome" class="clickable">Home</li>
        <li
          class="dropdown"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
          @click="toggleDropdown"
        >
          Genres
          <transition name="slide-fade">
            <ul v-show="showDropdown" class="dropdown-menu">
              <li
                v-for="genre in genres"
                :key="genre.id"
                @click.stop="selectGenre(genre.id)"
              >
                {{ genre.name }}
              </li>
            </ul>
          </transition>
        </li>
      </ul>
    </div>

    <div class="search-bar">
      <input v-model="query" type="search" placeholder="Search movies.." />
      <button @click="searchMovies">Search</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: ["genres"],
  data() {
    return {
      query: "",
      showDropdown: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    toggleDropdown() {
      if (window.innerWidth <= 768) {
        this.showDropdown = !this.showDropdown;
      }
    },
    handleMouseEnter() {
      if (window.innerWidth > 768) {
        this.showDropdown = true;
      }
    },
    handleMouseLeave() {
      if (window.innerWidth > 768) {
        this.showDropdown = false;
      }
    },
    handleOutsideClick(event) {
      const dropdown = this.$el.querySelector(".dropdown");
      if (dropdown && !dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    searchMovies() {
      if (this.$route.path !== "/") {
        this.$router.push("/").then(() => {
          this.$emit("search", { query: this.query, genre: null });
        });
      } else {
        this.$emit("search", { query: this.query, genre: null });
      }
    },
    goHome() {
      this.query = "";
      if (this.$route.path !== "/") {
        this.$router.push("/").then(() => {
          this.$emit("search", { query: "", genre: null });
        });
      } else {
        this.$emit("search", { query: "", genre: null });
      }
    },
    selectGenre(genreId) {
      this.query = "";
      this.showDropdown = false;
      if (this.$route.path !== "/") {
        this.$router.push("/").then(() => {
          this.$emit("search", { query: "", genre: genreId });
        });
      } else {
        this.$emit("search", { query: "", genre: genreId });
      }
    },
  },
};
</script>

<style scoped>
.nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: black;
  padding: 10px 20px;
  color: white;
  box-shadow: 0 1px 8px rgb(115, 17, 17);
}

.main {
  display: flex;
  align-items: center;
  gap: 20px;
}

.head {
  list-style: none;
  display: flex;
  gap: 15px;
  margin: 0;
  padding: 0;
  position: relative;
}

.clickable {
  cursor: pointer;
}

.logo {
  font-size: 25px;
  font-weight: bold;
  color: red;
  cursor: pointer;
}

.dropdown {
  position: relative;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: rgb(34, 34, 34);
  padding: 10px 0;
  border-radius: 6px;
  min-width: 120px;
  z-index: 1000;
}

.dropdown-menu li {
  padding: 6px 14px;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-menu li:hover {
  background-color: #ff4444;
}

.search-bar {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
}

.search-bar input[type="search"] {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  outline: none;
  background-color: rgb(68, 66, 66);
  color: white;
  width: 200px;
}

.search-bar button {
  padding: 8px 14px;
  background-color: #ff4444;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.search-bar button:hover {
  background-color: #cc0000;
}

/* Slide + Fade Animation */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .nav {
    flex-direction: column;
    align-items: flex-start;
  }
  .main {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .head {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
  .search-bar {
    width: 100%;
    margin-top: 10px;
  }
  .search-bar input[type="search"] {
    width: 100%;
  }
  .dropdown-menu {
    position: static;
    width: 100%;
    border-radius: 0;
  }
}
</style>




